module.exports = __webpack_public_path__ + "img/icon-drop.e3a79198.svg";